<template>
  <div class="upload-file">
    <div class="upload-info">
      <div class="upload-name ellipsified-type">{{ filename }}</div>
      <base-icon class="icon-button upload-cancel" name="close" @click="cancelUpload" />
    </div>
    <div class="progress-container">
      <progress-determinate :progress="progress" />
    </div>
  </div>
</template>

<script>
import BaseIcon from 'vuecomponents/base_icon'
import ProgressDeterminate from 'vuecomponents/progress_determinate'
import UploadFileMixin from 'vuemixins/upload_file_mixin'

export default {
  components: { BaseIcon, ProgressDeterminate },
  mixins: [UploadFileMixin]
}
</script>

<style lang="scss" scoped>
.upload-info {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
}
.upload-name {
  padding: 8px;
}
</style>
